"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectStockAdjustmentSchema = exports.createStockAdjustmentSchema = exports.stockAdjustmentShape = void 0;
const zod_1 = require("zod");
exports.stockAdjustmentShape = {
    /** Both are worked out by the server from the batch (its store, and that store's branch) — a caller may still send them; the store must then be the batch's own. */
    branchId: zod_1.z.string().uuid().optional(),
    locationId: zod_1.z.string().uuid().optional(),
    batchId: zod_1.z.string().uuid(),
    adjustmentType: zod_1.z.enum(['IN', 'OUT']),
    reasonId: zod_1.z.string().uuid(),
    quantity: zod_1.z.number().positive(),
    remarks: zod_1.z.string().optional(),
};
exports.createStockAdjustmentSchema = zod_1.z.object(exports.stockAdjustmentShape);
exports.rejectStockAdjustmentSchema = zod_1.z.object({ reason: zod_1.z.string().min(1) });
//# sourceMappingURL=stock-adjustment.schema.js.map